import { range } from 'lodash/util';

function calculatePositions(positions, spacing, seatSize, center) {
    const list = [];
    range(positions).forEach((id) => {
        const position = (seatSize * (id + 1)) + (spacing * id) + center;
        list.push(position);
    });
    const first = list.shift();
    list.unshift(first);
    const last = list.pop();
    list.push(last);

    const width = (last - first) + seatSize;
    return list.map(item => item - width / 2);
}

function calculateRectangularSeatAxis(index, dimensions, axialCount, spacing, seatSize) {
    const { width, height } = dimensions;
    const {
        north,
        south,
        east,
        west,
    } = axialCount;
    if (north > 0 && index <= north) {
        const northPositions = calculatePositions(north, spacing.v, seatSize, width / 2);
        return {
            x: northPositions[index - 1],
            y: -spacing.h - seatSize / 2,
        };
    }
    if (east > 0 && index > north && index <= (north + east)) {
        const eastPositions = calculatePositions(east, spacing.h, seatSize, height / 2);
        return {
            x: width + spacing.v + seatSize,
            y: eastPositions[index - north - 1] - seatSize / 2,
        };
    }
    if (south > 0 && index > (north + east) && index <= (north + east + south)) {
        const southPositions = calculatePositions(south, spacing.v, seatSize, width / 2).reverse();
        return {
            x: southPositions[index - north - east - 1],
            y: height + spacing.h + seatSize / 2,
        };
    }
    if (west > 0 && index > (north + east + south) && index <= (north + east + south + west)) {
        const westPositions = calculatePositions(west, spacing.h, seatSize, height / 2).reverse();
        return {
            x: -spacing.v,
            y: westPositions[index - north - east - south - 1] - seatSize / 2,
        };
    }

    return { x: 0, y: 0 };
}

export default calculateRectangularSeatAxis;
